// time window for hash validity
export const HASH_VALIDITY_INTERVAL = 1000 * 60 * 0.75; // 45 seconds

export interface DataSet {
  label: string;
  values: {
    raw: number[];
  };
}

export interface TotalsDataSet {
  values: {
    raw: number[];
  };
}

export type ScoreCardData = {
  hasData: boolean;
  yColumn: { name: string; label: string };
  dataSets: DataSet[];
  totalsDataSet: TotalsDataSet;
  dataLabels?: string[][];
};

interface DataObject {
  [key: string]: string | number;
}

export interface AppliedFilter {
  filter_label: string;
  filter_name: string;
  filter_type: string;
  filter_value: string[];
}
export interface BrandObject extends DataObject {
  brand: string;
}

export interface PricesObject extends DataObject {
  price_class: string;
}

export type KpisDataObject = BrandObject | PricesObject;

interface BrandsChartData {
  brands: BrandObject[];
  focus_brand?: string;
  my_brand: string;
}

interface PricesChartData {
  price_classes: PricesObject[];
}

type GroupingChartData = BrandsChartData | PricesChartData;

export type ChartData = {
  market: string[];
  period: string;
  market_totals: Record<string, Record<string, number>>;
  currency: string;
  average_selling_price?: Array<Record<string, number | string>>;
} & GroupingChartData;

export interface OutputStructure {
  chartId?: string;
  proposition: string;
  chartData: ChartData;
  contextualData: Record<string, unknown>;
  filters?: AppliedFilter[];
  [key: string]: unknown;
}

export type BrandEntity = {
  options?: { label?: string }[];
};
